import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SapiEntity, SapiService } from './sapi.service';
import { OverlayService, DialogDefinition } from './overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { BbTableService } from './bb-table.service';

@Injectable()
export class EntityService {

	constructor(
		private sapiService: SapiService,
		private overlayService: OverlayService,
		private translate: TranslateService
	) {

	}

	deleteEntity(entity: SapiEntity, entityName: string, entityTranslation?: string, dialogContents?: string, bbTableService?: BbTableService) {
		if (!entityTranslation) {
			entityTranslation = this.translate.instant(entityName.toUpperCase()).toLowerCase();
		}
		if (!dialogContents) {
			dialogContents = this.translate.instant('DELETE_ENTITY_CONFIRM', { entity: entityTranslation });
		}

		const dialog: DialogDefinition = {
			icon: 'trash',
			title: this.translate.instant('DELETING_ENTITY', { entity: entityTranslation, id: (entity as any).name || (entity as any).title || entity.id }),
			contents: dialogContents,
			onConfirm: () => {
				const returnObservable: Observable<any> = this.sapiService.delete(entityName, entity.id);

				returnObservable.subscribe(() => {
					if (bbTableService) {
						bbTableService.removeRows([entity.id]);
					}

					this.overlayService.createToast(this.translate.instant('ENTITY_DELETED',
						{ id: entity.id, entity: entityTranslation }), 'trash');

				});

				return returnObservable;
			}
		};

		this.overlayService.createDialog(dialog);
	}

	getRelations(entity: SapiEntity): any {
		const relationRef = {};
		if (entity?.relationLabel?.length) {
			entity.relationLabel.forEach((label) => {
				const entityTypePartRegex = new RegExp(/[a-zA-Z]+/g);
				const entityType = label.match(entityTypePartRegex) && label.match(entityTypePartRegex)[0];
				const id = label.split(entityType)[1];
				if (entityType && id) {
					const ref = relationRef[entityType.toLowerCase()] = relationRef[entityType.toLowerCase()] || [];
					ref.push(id);
				}
			});
		}
		return relationRef;
	}
}
